import useUpdateAccessRole from 'hooks/Auth/useUpdateAccessRole';
import { useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { ROUTES } from 'router/const';

export const useBootstrapAccessRole = () => {
  const location = useLocation();
  const { updateAccessRole } = useUpdateAccessRole();
  const [isReady, setIsReady] = useState(false);

  const isEmbed = !!matchPath({ path: ROUTES.EMBED.PATH, end: false }, location.pathname);

  // 초기 1회 권한 세팅
  useEffect(() => {
    if (isEmbed) {
      setIsReady(true);
      return;
    }

    const initialize = async () => {
      await updateAccessRole();
      setIsReady(true);
    };
    initialize();
  }, []);

  // 초기화 이후 pathname 변화 감지
  useEffect(() => {
    if (!isReady || isEmbed) return;
    updateAccessRole();
  }, [location.pathname, isReady, isEmbed]);

  return isReady;
};
